module.exports = __webpack_public_path__ + "img/GUI_CountryExtensions.8c0ea2a8.png";